import { CALL_API } from './../../middlewares/api';

const onLoadConsumoAguaIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_CONSUMO_AGUA_UNIDADES',
    endpoint: 'consumo',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'agua' }
    }
  }
});

const onLoadConsumoAguaExterno = () => ({
  [CALL_API]: {
    type: 'LIST_CONSUMO_AGUA_UNIDADES',
    endpoint: 'consumo',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'externo' }
    }
  }
});

const onLoadConsumoAgua = () => (dispatch, getState) => {
  let { fetching, errors } = getState().consumo.agua;
  if (!fetching && !errors.length) {
    return dispatch(onLoadConsumoAguaIfNeeded());
  }
};

const onLoadConsumoAguaMineralIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_CONSUMO_AGUA_MINERAL_UNIDADES',
    endpoint: 'consumo',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'agua-mineral' }
    }
  }
});

const onLoadConsumoAguaMineral = () => (dispatch, getState) => {
  let { fetching, errors } = getState().consumo.aguaMineral;
  if (!fetching && !errors.length) {
    return dispatch(onLoadConsumoAguaMineralIfNeeded());
  }
};

const onLoadConsumoAguaMineralMarcaIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_MARCAS_AGUA_MINERAL_UNIDADES',
    endpoint: 'consumo',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'agua-mineral-marcas' }
    }
  }
});

const onLoadConsumoAguaMineralMarca = () => (dispatch, getState) => {
  const { marcas } = getState().consumo;
  if (!marcas.fetching) {
    return dispatch(onLoadConsumoAguaMineralMarcaIfNeeded());
  }
  return Promise.resolve(marcas);
};

const onLoadDetalheConsumoAguaMineralIfNeeded = value => ({
  [CALL_API]: {
    type: 'DETAIL_CONSUMO_AGUA_MINERAL_UNIDADES',
    endpoint: 'consumo',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'detalhe-agua-mineral', unidade: value.unidade, competencia: value.competencia, produto: value.id_produto }
    }
  },
  value
});

const onLoadDetalheConsumoAguaMineral = value => dispatch => {
  let { fetching, errors = [] } = value.detail || {};
  if (!fetching && !errors.length) {
    return dispatch(onLoadDetalheConsumoAguaMineralIfNeeded(value));
  }
  return Promise.resolve(value);
};

const solicitaAguaMineral = value => ({
  [CALL_API]: {
    type: 'INSERT_CONSUMO_AGUA_MINERAL_UNIDADES',
    endpoint: 'consumo',
    authenticated: true,
    config: {
      method: 'POST',
      querystring: { type: 'agua-mineral' },
      body: value
    }
  },
  value
});

export default {
  solicitaAguaMineral,
  onLoadConsumoAgua,
  onLoadConsumoAguaExterno,
  onLoadConsumoAguaMineral,
  onLoadConsumoAguaMineralIfNeeded,
  onLoadDetalheConsumoAguaMineral,
  onLoadConsumoAguaMineralMarca
}


// WEBPACK FOOTER //
// ./src/modules/consumo/actions.js